const MenuClose = (props: React.HTMLAttributes<SVGElement>): JSX.Element => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      className="fill-color"
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.9359 3.93934C18.5217 3.35352 19.4714 3.35352 20.0571 3.93934C20.6429 4.52515 20.6429 5.47495 20.0571 6.06076L14.1194 11.9991L20.0571 17.9374C20.6429 18.5232 20.6429 19.473 20.0571 20.0588C19.4714 20.6446 18.5217 20.6446 17.9359 20.0588L11.9982 14.1205L6.06056 20.0587C5.4748 20.6446 4.5251 20.6446 3.93934 20.0587C3.35359 19.4729 3.35359 18.5231 3.93934 17.9373L9.87697 11.9991L3.93934 6.06084C3.35359 5.47503 3.35359 4.52523 3.93934 3.93942C4.5251 3.3536 5.4748 3.3536 6.06056 3.93942L11.9982 9.87765L17.9359 3.93934Z"
      fill="var(--color-blue)"
    />
  </svg>
);
export default MenuClose;
